var map = {
	"./day/cloudy.svg": 1612,
	"./day/fog.svg": 1588,
	"./day/freezingrain.svg": 1746,
	"./day/heavyrain.svg": 8971,
	"./day/heavyshower.svg": 8787,
	"./day/humidity.svg": 4323,
	"./day/humidity_new.svg": 8236,
	"./day/lightning.svg": 4938,
	"./day/lightrain.svg": 1730,
	"./day/lightshower.svg": 6310,
	"./day/lightsnow.svg": 9553,
	"./day/mostlycloudy.svg": 2812,
	"./day/partlycloudy.svg": 2174,
	"./day/pressure_new.svg": 3794,
	"./day/rain.svg": 6726,
	"./day/shower.svg": 7370,
	"./day/snow.svg": 8757,
	"./day/snowrain.svg": 5695,
	"./day/snowrainshower.svg": 3513,
	"./day/snowshower.svg": 6727,
	"./day/sunny.svg": 7517,
	"./day/synchro.svg": 3698,
	"./day/temperature_new.svg": 705,
	"./day/thunderstorm.svg": 5237,
	"./day/unknow.svg": 1212,
	"./day/uv_new.svg": 6874,
	"./day/wind.svg": 9718,
	"./day/windDirection_new.svg": 3018,
	"./night/cloudy.svg": 7928,
	"./night/fog.svg": 1344,
	"./night/freezingrain.svg": 2142,
	"./night/heavyrain.svg": 9911,
	"./night/heavyshower.svg": 7807,
	"./night/lightning.svg": 9566,
	"./night/lightrain.svg": 2150,
	"./night/lightshower.svg": 3082,
	"./night/lightsnow.svg": 2597,
	"./night/mostlycloudy.svg": 5464,
	"./night/partlycloudy.svg": 266,
	"./night/rain.svg": 4842,
	"./night/shower.svg": 9310,
	"./night/snow.svg": 5241,
	"./night/snowrain.svg": 1787,
	"./night/snowrainshower.svg": 7629,
	"./night/snowshower.svg": 3011,
	"./night/sunny.svg": 5097,
	"./night/thunderstorm.svg": 5681,
	"./night/unknow.svg": 4784,
	"./night/wind.svg": 3850
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9700;